module.exports = __webpack_public_path__ + "assets/img/3-320x320.b2f47a0c.webp";